import { render } from "./ChipLabel.vue?vue&type=template&id=2c6f6ea0"
import script from "./ChipLabel.vue?vue&type=script&lang=js"
export * from "./ChipLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__